/**
 * @packageDocumentation
 * @module MediaObserver
 * @category Core
 */
import { InjectionToken, Provider } from '@angular/core';

/**
 * Настройка брекпоинтов.
 * Ключ - название брекпоинта, значение - верхний порог размера экрана в пикселях.
 *
 * @example
 * ```ts
 * {
 *   xs: 0,
 *   sm: 576,
 *   md: 768,
 *   lg: 992,
 *   xl: 1200,
 *   xxl: 1400,
 *   xxxl: 1600,
 * }
 * ```
 */
export const MEDIA_BREAKPOINTS_PROVIDER = new InjectionToken<MediaBreakpointsProvider>('Media breakpoints provider');

export type MediaBreakpointsProvider = Record<string, number>;

export function provideMediaBreakpoints(breakpoints: MediaBreakpointsProvider): Provider[] {
  return [
    {
      provide: MEDIA_BREAKPOINTS_PROVIDER,
      useValue: breakpoints,
    },
  ];
}
